import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { H2, ReviewRating } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError, intl } = props;

  return (
    <section className={css.sectionReviewsCard} id="reviews">
      <div className={css.sectionKicker}>
        <FormattedMessage id="ListingPage.reviewsKicker" />
      </div>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : (
        <div className={css.reviewsGrid}>
          {reviews.length > 0 ? (
            reviews.map(r => {
              const dateStr = intl.formatDate(r.attributes.createdAt, {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              });
              return (
                <div key={`Review_${r.id.uuid}`} className={css.reviewCard}>
                  <div className={css.reviewCardTop}>
                    <ReviewRating
                      rating={r.attributes.rating}
                      reviewStarClassName={css.reviewCardStar}
                    />
                    <span className={css.reviewCardDate}>{dateStr}</span>
                  </div>
                  <p className={css.reviewCardContent}>{r.attributes.content}</p>
                </div>
              );
            })
          ) : (
            <div className={css.reviewsEmpty}>
              <FormattedMessage id="ListingPage.reviewsEmpty" />
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default SectionReviews;
